import { Stack } from "@mui/material";
import type { Control, UseFormWatch } from "react-hook-form";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { Resources, useResource } from "Translations/Resources";
import type { CampaignFormData } from "./campaignFormSchema";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  control: Control<CampaignFormData>;
  isSubmitting: boolean;
  watch: UseFormWatch<CampaignFormData>;
};

export const ThankYouSection = ({ control, watch, isSubmitting }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={3}>
      <FormInput
        control={control}
        name="successfulPaymentText"
        label={t(RESOURCES.SuccessfulPaymentText)}
        fullWidth
        multiline
        rows={7}
        disabled={isSubmitting}
        placeholder={t(RESOURCES.SuccessfulPaymentTextPlaceholder)}
        helperText={t(RESOURCES.SuccessfulPaymentTextHelper, {
          count: watch("successfulPaymentText")?.length || 0,
        })}
      />

      <FormInput
        control={control}
        name="paymentInstructionsText"
        label={t(RESOURCES.PaymentInstructionsText)}
        fullWidth
        multiline
        rows={10}
        disabled={isSubmitting}
        placeholder={t(RESOURCES.PaymentInstructionsTextPlaceholder)}
        helperText={t(RESOURCES.PaymentInstructionsTextHelper, {
          count: watch("paymentInstructionsText")?.length || 0,
        })}
      />

      <FormInput
        control={control}
        name="onlyWithMooneText"
        label={t(RESOURCES.OnlyWithMooneText)}
        fullWidth
        multiline
        rows={10}
        disabled={isSubmitting}
        placeholder={t(RESOURCES.OnlyWithMooneTextPlaceholder)}
        helperText={t(RESOURCES.OnlyWithMooneTextHelper, {
          count: watch("onlyWithMooneText")?.length || 0,
        })}
      />
    </Stack>
  );
};
